import {
    Box,
    Card,
    styled,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import { RewardEntity } from 'api/generated';
import FlexBetween from 'components/flexbox/FlexBetween';
import { H5, Small } from 'components/Typography';
import { format } from 'date-fns';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import ScrollBar from 'simplebar-react';

const commonCSS = {
    minWidth: 120,
    '&:nth-of-type(1)': { minWidth: 170 },
};

// Styled components
const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:first-of-type': { paddingLeft: '1.5rem' },
    //   "&:last-of-type": { paddingRight: 0 },
}));

const StyledTableBodyCell = styled(TableCell)(({ theme }) => ({
    //   padding: 0,
    fontSize: 12,
    fontWeight: 500,
    paddingLeft: '1.5rem',
    //   paddingTop: "1rem",
    '&:first-of-type': { paddingLeft: '1.5rem' },
    //   "&:last-of-type": { paddingRight: 0 },
    [theme.breakpoints.down('sm')]: { ...commonCSS },
    [theme.breakpoints.between(960, 1270)]: { ...commonCSS },
}));

const StyledTableBody = styled(TableBody)(() => ({
    marginTop: '50px',
}));

interface EmployeeRewardsProps {
    rewards: RewardEntity[]
}

const EmployeeRewards: FC<EmployeeRewardsProps> = ({
    rewards
}) => {

    const { t } = useTranslation();

    return (
        <Card>
            <H5 mx={3} mt={3} mb={3}>
                {t('report.employeeRewards.Title')}
            </H5>
            {
                rewards.length === 0 ?
                    <></> :
                    <ScrollBar style={{ maxHeight: '300px' }}>
                        <Table>
                            <caption><FlexBetween width={'100%'}>
                                <H5 marginLeft={2}>{t('total')}</H5>
                                <H5 marginRight={2}>
                                    {rewards
                                        .map((rw) => { return Number(rw.amount) })
                                        .reduce((a, b) => {
                                            return a + b;
                                        }, 0)
                                        .toFixed(2)
                                    } €
                                </H5>
                            </FlexBetween></caption>
                            <TableHead>
                                <TableRow>
                                    <StyledTableHeadCell align='center'>{t('employees.reward.name')}</StyledTableHeadCell>
                                    <StyledTableHeadCell align='center'>{t('employees.reward.amount')}</StyledTableHeadCell>
                                    <StyledTableHeadCell align='center'>{t('employees.reward.earnedon')}</StyledTableHeadCell>
                                    <StyledTableHeadCell align='center'>{t('employees.reward.notes')}</StyledTableHeadCell>
                                </TableRow>
                            </TableHead>

                            <StyledTableBody>
                                {rewards.map((item, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{
                                            backgroundColor:
                                                index % 2 === 0 ? 'action.hover' : 'transparent',
                                        }}
                                    >
                                        <StyledTableBodyCell align='center'>
                                            <Box>
                                                <Small ml='1rem'>{item.name.name}</Small>
                                            </Box>
                                        </StyledTableBodyCell>

                                        <StyledTableBodyCell align='center'>{Number(item.amount).toFixed(2)} €</StyledTableBodyCell>
                                        <StyledTableBodyCell align='center'>
                                            {format(new Date(item.earnedOn), 'dd/MM/yyyy')}
                                        </StyledTableBodyCell>
                                        <StyledTableBodyCell align='center'>
                                            {item.notes}
                                        </StyledTableBodyCell>
                                    </TableRow>
                                ))}
                            </StyledTableBody>
                        </Table>
                    </ScrollBar>
            }
        </Card>
    );
};

export default EmployeeRewards;
